export default class AuthInterceptorService {

  $get($q, localStorageService) {

    return {
      request: (config) => {

        config.headers = config.headers || {};
        var authData = localStorageService.get('authorizationData');
        if (authData) {
          config.headers.Authorization = 'Bearer ' + authData.token;
        }

        return config;
      },

      responseError: (rejection) => {
        if (rejection.status === 401) {
          app.$location.path('/login');
        }
        return $q.reject(rejection);
      }
    };
  }
}

AuthInterceptorService.prototype.$get.$inject = ['$q', 'localStorageService'];



// WEBPACK FOOTER //
// ./app/authInterceptorService.js